import { Auth } from '@nackle/bridge';
import { idURL } from 'appEndpoints';
import { applyRequestMiddleware } from './fetch';

const auth = new Auth( {
    authority: idURL,
    automaticSilentRenew: false,
    // companyId: '2eddede7-12e0-493a-ba36-3940b96b1cac'
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} )
    };

    if ( auth.state.accessToken ) {
        options.headers.authorization = `Bearer ${ auth.state.accessToken } `;
    }
} );

